export type CountryOption = {
  label: string;
  iso2: string;
};

export const COUNTRIES: readonly CountryOption[] = [
  { label: 'Afghanistan', iso2: 'AF' },
  { label: 'Albania', iso2: 'AL' },
  { label: 'Algeria', iso2: 'DZ' },
  { label: 'Andorra', iso2: 'AD' },
  { label: 'Angola', iso2: 'AO' },
  { label: 'Antigua and Barbuda', iso2: 'AG' },
  { label: 'Argentina', iso2: 'AR' },
  { label: 'Armenia', iso2: 'AM' },
  { label: 'Australia', iso2: 'AU' },
  { label: 'Austria', iso2: 'AT' },
  { label: 'Azerbaijan', iso2: 'AZ' },
  { label: 'Bahamas', iso2: 'BS' },
  { label: 'Bahrain', iso2: 'BH' },
  { label: 'Bangladesh', iso2: 'BD' },
  { label: 'Barbados', iso2: 'BB' },
  { label: 'Belarus', iso2: 'BY' },
  { label: 'Belgium', iso2: 'BE' },
  { label: 'Belize', iso2: 'BZ' },
  { label: 'Benin', iso2: 'BJ' },
  { label: 'Bhutan', iso2: 'BT' },
  { label: 'Bolivia', iso2: 'BO' },
  { label: 'Bosnia and Herzegovina', iso2: 'BA' },
  { label: 'Botswana', iso2: 'BW' },
  { label: 'Brazil', iso2: 'BR' },
  { label: 'Brunei', iso2: 'BN' },
  { label: 'Bulgaria', iso2: 'BG' },
  { label: 'Burkina Faso', iso2: 'BF' },
  { label: 'Burundi', iso2: 'BI' },
  { label: 'Cabo Verde', iso2: 'CV' },
  { label: 'Cambodia', iso2: 'KH' },
  { label: 'Cameroon', iso2: 'CM' },
  { label: 'Canada', iso2: 'CA' },
  { label: 'Central African Republic', iso2: 'CF' },
  { label: 'Chad', iso2: 'TD' },
  { label: 'Chile', iso2: 'CL' },
  { label: 'China', iso2: 'CN' },
  { label: 'Colombia', iso2: 'CO' },
  { label: 'Comoros', iso2: 'KM' },
  { label: 'Congo', iso2: 'CG' },
  { label: 'Costa Rica', iso2: 'CR' },
  { label: "Cote d'Ivoire", iso2: 'CI' },
  { label: 'Croatia', iso2: 'HR' },
  { label: 'Cuba', iso2: 'CU' },
  { label: 'Cyprus', iso2: 'CY' },
  { label: 'Czechia', iso2: 'CZ' },
  { label: 'Democratic Republic of the Congo', iso2: 'CD' },
  { label: 'Denmark', iso2: 'DK' },
  { label: 'Djibouti', iso2: 'DJ' },
  { label: 'Dominica', iso2: 'DM' },
  { label: 'Dominican Republic', iso2: 'DO' },
  { label: 'Ecuador', iso2: 'EC' },
  { label: 'Egypt', iso2: 'EG' },
  { label: 'El Salvador', iso2: 'SV' },
  { label: 'Equatorial Guinea', iso2: 'GQ' },
  { label: 'Eritrea', iso2: 'ER' },
  { label: 'Estonia', iso2: 'EE' },
  { label: 'Eswatini', iso2: 'SZ' },
  { label: 'Ethiopia', iso2: 'ET' },
  { label: 'Fiji', iso2: 'FJ' },
  { label: 'Finland', iso2: 'FI' },
  { label: 'France', iso2: 'FR' },
  { label: 'Gabon', iso2: 'GA' },
  { label: 'Gambia', iso2: 'GM' },
  { label: 'Georgia', iso2: 'GE' },
  { label: 'Germany', iso2: 'DE' },
  { label: 'Ghana', iso2: 'GH' },
  { label: 'Greece', iso2: 'GR' },
  { label: 'Grenada', iso2: 'GD' },
  { label: 'Guatemala', iso2: 'GT' },
  { label: 'Guinea', iso2: 'GN' },
  { label: 'Guinea-Bissau', iso2: 'GW' },
  { label: 'Guyana', iso2: 'GY' },
  { label: 'Haiti', iso2: 'HT' },
  { label: 'Honduras', iso2: 'HN' },
  { label: 'Hungary', iso2: 'HU' },
  { label: 'Iceland', iso2: 'IS' },
  { label: 'India', iso2: 'IN' },
  { label: 'Indonesia', iso2: 'ID' },
  { label: 'Iran', iso2: 'IR' },
  { label: 'Iraq', iso2: 'IQ' },
  { label: 'Ireland', iso2: 'IE' },
  { label: 'Israel', iso2: 'IL' },
  { label: 'Italy', iso2: 'IT' },
  { label: 'Jamaica', iso2: 'JM' },
  { label: 'Japan', iso2: 'JP' },
  { label: 'Jordan', iso2: 'JO' },
  { label: 'Kazakhstan', iso2: 'KZ' },
  { label: 'Kenya', iso2: 'KE' },
  { label: 'Kiribati', iso2: 'KI' },
  { label: 'Kosovo', iso2: 'XK' },
  { label: 'Kuwait', iso2: 'KW' },
  { label: 'Kyrgyzstan', iso2: 'KG' },
  { label: 'Laos', iso2: 'LA' },
  { label: 'Latvia', iso2: 'LV' },
  { label: 'Lebanon', iso2: 'LB' },
  { label: 'Lesotho', iso2: 'LS' },
  { label: 'Liberia', iso2: 'LR' },
  { label: 'Libya', iso2: 'LY' },
  { label: 'Liechtenstein', iso2: 'LI' },
  { label: 'Lithuania', iso2: 'LT' },
  { label: 'Luxembourg', iso2: 'LU' },
  { label: 'Madagascar', iso2: 'MG' },
  { label: 'Malawi', iso2: 'MW' },
  { label: 'Malaysia', iso2: 'MY' },
  { label: 'Maldives', iso2: 'MV' },
  { label: 'Mali', iso2: 'ML' },
  { label: 'Malta', iso2: 'MT' },
  { label: 'Marshall Islands', iso2: 'MH' },
  { label: 'Mauritania', iso2: 'MR' },
  { label: 'Mauritius', iso2: 'MU' },
  { label: 'Mexico', iso2: 'MX' },
  { label: 'Micronesia', iso2: 'FM' },
  { label: 'Moldova', iso2: 'MD' },
  { label: 'Monaco', iso2: 'MC' },
  { label: 'Mongolia', iso2: 'MN' },
  { label: 'Montenegro', iso2: 'ME' },
  { label: 'Morocco', iso2: 'MA' },
  { label: 'Mozambique', iso2: 'MZ' },
  { label: 'Myanmar', iso2: 'MM' },
  { label: 'Namibia', iso2: 'NA' },
  { label: 'Nauru', iso2: 'NR' },
  { label: 'Nepal', iso2: 'NP' },
  { label: 'Netherlands', iso2: 'NL' },
  { label: 'New Zealand', iso2: 'NZ' },
  { label: 'Nicaragua', iso2: 'NI' },
  { label: 'Niger', iso2: 'NE' },
  { label: 'Nigeria', iso2: 'NG' },
  { label: 'North Korea', iso2: 'KP' },
  { label: 'North Macedonia', iso2: 'MK' },
  { label: 'Norway', iso2: 'NO' },
  { label: 'Oman', iso2: 'OM' },
  { label: 'Pakistan', iso2: 'PK' },
  { label: 'Palau', iso2: 'PW' },
  { label: 'Palestine', iso2: 'PS' },
  { label: 'Panama', iso2: 'PA' },
  { label: 'Papua New Guinea', iso2: 'PG' },
  { label: 'Paraguay', iso2: 'PY' },
  { label: 'Peru', iso2: 'PE' },
  { label: 'Philippines', iso2: 'PH' },
  { label: 'Poland', iso2: 'PL' },
  { label: 'Portugal', iso2: 'PT' },
  { label: 'Qatar', iso2: 'QA' },
  { label: 'Romania', iso2: 'RO' },
  { label: 'Russia', iso2: 'RU' },
  { label: 'Rwanda', iso2: 'RW' },
  { label: 'Saint Kitts and Nevis', iso2: 'KN' },
  { label: 'Saint Lucia', iso2: 'LC' },
  { label: 'Saint Vincent and the Grenadines', iso2: 'VC' },
  { label: 'Samoa', iso2: 'WS' },
  { label: 'San Marino', iso2: 'SM' },
  { label: 'Sao Tome and Principe', iso2: 'ST' },
  { label: 'Saudi Arabia', iso2: 'SA' },
  { label: 'Senegal', iso2: 'SN' },
  { label: 'Serbia', iso2: 'RS' },
  { label: 'Seychelles', iso2: 'SC' },
  { label: 'Sierra Leone', iso2: 'SL' },
  { label: 'Singapore', iso2: 'SG' },
  { label: 'Slovakia', iso2: 'SK' },
  { label: 'Slovenia', iso2: 'SI' },
  { label: 'Solomon Islands', iso2: 'SB' },
  { label: 'Somalia', iso2: 'SO' },
  { label: 'South Africa', iso2: 'ZA' },
  { label: 'South Korea', iso2: 'KR' },
  { label: 'South Sudan', iso2: 'SS' },
  { label: 'Spain', iso2: 'ES' },
  { label: 'Sri Lanka', iso2: 'LK' },
  { label: 'Sudan', iso2: 'SD' },
  { label: 'Suriname', iso2: 'SR' },
  { label: 'Sweden', iso2: 'SE' },
  { label: 'Switzerland', iso2: 'CH' },
  { label: 'Syria', iso2: 'SY' },
  { label: 'Taiwan', iso2: 'TW' },
  { label: 'Tajikistan', iso2: 'TJ' },
  { label: 'Tanzania', iso2: 'TZ' },
  { label: 'Thailand', iso2: 'TH' },
  { label: 'Timor-Leste', iso2: 'TL' },
  { label: 'Togo', iso2: 'TG' },
  { label: 'Tonga', iso2: 'TO' },
  { label: 'Trinidad and Tobago', iso2: 'TT' },
  { label: 'Tunisia', iso2: 'TN' },
  { label: 'Turkey', iso2: 'TR' },
  { label: 'Turkmenistan', iso2: 'TM' },
  { label: 'Tuvalu', iso2: 'TV' },
  { label: 'Uganda', iso2: 'UG' },
  { label: 'Ukraine', iso2: 'UA' },
  { label: 'United Arab Emirates', iso2: 'AE' },
  { label: 'United Kingdom', iso2: 'GB' },
  { label: 'United States', iso2: 'US' },
  { label: 'Uruguay', iso2: 'UY' },
  { label: 'Uzbekistan', iso2: 'UZ' },
  { label: 'Vanuatu', iso2: 'VU' },
  { label: 'Vatican City', iso2: 'VA' },
  { label: 'Venezuela', iso2: 'VE' },
  { label: 'Vietnam', iso2: 'VN' },
  { label: 'Yemen', iso2: 'YE' },
  { label: 'Zambia', iso2: 'ZM' },
  { label: 'Zimbabwe', iso2: 'ZW' },
] as const;

export const SWITZERLAND = COUNTRIES.find((country) => country.iso2 === 'CH')!;

export function getCountryIso2(value?: string | null, fallback = ''): string {
  if (!value) return fallback;
  return COUNTRIES.find((country) => country.iso2 === value || country.label === value)?.iso2 ?? fallback;
}

export function getCountryLabel(value?: string | null, fallback = ''): string {
  if (!value) return fallback;
  return (
    COUNTRIES.find((country) => country.iso2 === value || country.label === value)?.label ?? (fallback || value || '')
  );
}
